import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/sph-code.png';
import _imports_1 from '@/assets/img/footer/vector.svg';
import _imports_2 from '@/assets/img/gzh-code.png';
import _imports_3 from '@/assets/img/footer/file.svg';
import _imports_4 from '@/assets/img/xcx-code.jpg';
import _imports_5 from '@/assets/img/footer/applet.svg';
import _imports_6 from '@/assets/img/arrow.svg';
import _imports_7 from '@/assets/img/sph-code.jpg';
import _imports_8 from '@/assets/img/gzh-code.jpg';
const _withScopeId = n => (_pushScopeId("data-v-d670c9f0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "footer"
};
const _hoisted_2 = {
  class: "f-container"
};
const _hoisted_3 = {
  class: "f-nav"
};
const _hoisted_4 = ["href", "onClick"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
const _hoisted_6 = {
  class: "commer"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "商务合作", -1));
const _hoisted_8 = {
  class: "phone-box"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "color-gray"
}, "联系电话: ", -1));
const _hoisted_10 = ["href"];
const _hoisted_11 = ["href"];
const _hoisted_12 = ["href"];
const _hoisted_13 = {
  class: "applets"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "applets-code"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
})]), /*#__PURE__*/_createElementVNode("p", null, "关注微信视频号")], -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
const _hoisted_16 = [_hoisted_15];
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "applets-code"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
})]), /*#__PURE__*/_createElementVNode("p", null, "关注微信公众号")], -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3
}, null, -1));
const _hoisted_19 = [_hoisted_18];
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "applets-code"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4
})]), /*#__PURE__*/_createElementVNode("p", null, "关注微信小程序")], -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5
}, null, -1));
const _hoisted_22 = [_hoisted_21];
const _hoisted_23 = {
  class: "f-bottom"
};
const _hoisted_24 = {
  class: "f-copyright"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Copyright © 2020 重庆亲笔签数字科技有限公司版权所有", -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "split"
}, "|", -1));
const _hoisted_27 = {
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "split"
}, "|", -1));
const _hoisted_29 = {
  key: 1,
  class: "footer-m"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "fold"
}, null, -1));
const _hoisted_31 = ["href", "onClick"];
const _hoisted_32 = {
  class: "commer"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "商务合作", -1));
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "color-gray"
}, "联系电话：", -1));
const _hoisted_35 = ["href"];
const _hoisted_36 = ["href"];
const _hoisted_37 = ["href"];
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "color-gray"
}, "咨询邮箱：", -1));
const _hoisted_39 = {
  class: "applets"
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "max-pic"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  "show-menu-by-longpress": true
})], -1));
const _hoisted_41 = {
  class: "item"
};
const _hoisted_42 = ["src"];
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "视频号", -1));
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "max-pic"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  "show-menu-by-longpress": true
})], -1));
const _hoisted_45 = {
  class: "item"
};
const _hoisted_46 = ["src"];
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "公众号", -1));
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "max-pic"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4
})], -1));
const _hoisted_49 = {
  class: "item"
};
const _hoisted_50 = ["src"];
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "小程序", -1));
const _hoisted_52 = {
  class: "f-bottom"
};
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Copyright © 2020 重庆亲笔签数字科技有限公司版权所有", -1));
const _hoisted_54 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "split"
}, "|", -1));
const _hoisted_55 = {
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
};
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "split"
}, "|", -1));
import { ref, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { $track } from '@/plugins/Track';
import { isMobile } from '@/utils';
import { getUrllink } from '@/api';
import vadioCode from '@/assets/img/sph-code.png';
import wechartCode from '@/assets/img/gzh-code.png';
import appCode from '@/assets/img/xcx-code.png';
export default {
  __name: 'index',
  setup(__props) {
    const basePath = window.appConfig.VUE_APP_PATH;
    const data = {
      phone: '400-6868-860',
      phone_: '4006868860',
      tel: '023-89690366',
      tel_: '02389690366',
      email: 'wengmin@aoscript.com',
      licens: '渝B2-20200157号',
      icp: '14005317号-11',
      record: '50019002502797',
      links: [{
        title: '产品服务',
        list: [{
          msg: 'SaaS电子合同',
          href: `${basePath}saas`
        }, {
          msg: '开放平台',
          href: `${basePath}open`
        }, {
          msg: '文件验签',
          href: `${basePath}product`
        }]
      }, {
        title: '快速入口',
        list: [{
          msg: '立即注册',
          href: 'javascript:;',
          jump: 'registUrl'
        }, {
          msg: '立即登录',
          href: 'javascript:;',
          jump: 'loginUrl'
        }]
      }, {
        title: '服务支持',
        list: [{
          msg: '帮助中心',
          href: `${basePath}help`
        }, {
          msg: '售后支持',
          href: 'javascript:;',
          jump: 'callCustomer'
        }, {
          msg: '联系我们',
          href: 'javascript:;',
          jump: 'callCustomer'
        }]
      }, {
        title: '新闻资讯',
        list: [{
          msg: '公司动态',
          href: `${basePath}news?tab=crop`
        }, {
          msg: '政策解读',
          href: `${basePath}news?tab=policy`
        }, {
          msg: '知识科普',
          href: `${basePath}news?tab=know`
        }]
      }, {
        title: '关于我们',
        list: [{
          msg: '公司介绍',
          href: `${basePath}about/us`
        }
        // { msg: '笔迹大数据研究院', href: `${basePath}about/acade` },
        ]
      }]
    };

    const footerShow = ref(true);
    const router = useRouter();
    watch(() => router.currentRoute.value.path, toPath => {
      if (toPath.includes('demo')) {
        footerShow.value = false;
      } else {
        footerShow.value = true;
      }
    });
    const openUrl = async url => {
      if (url === 'callCustomer') {
        return TUNGEE_IM.run('show');
      }
      if (!isMobile()) {
        return window.open(window.appConfig[url], '_blank');
      }
      const link = await getUrllink();
      location.href = link;
    };

    // 上报用户行为
    const reportHandle = name => {
      $track('WebsiteUsersClick', {
        button_name: `悬停${name}`,
        click_info: name,
        event_source: '页脚导航',
        event_target: '扫码',
        event_target_pam: null,
        event_source_pam: null
      });
    };
    const scrollTop = () => {
      window.scrollTo(0, 0);
    };
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_menu_item = _resolveComponent("a-menu-item");
      const _component_a_sub_menu = _resolveComponent("a-sub-menu");
      const _component_a_menu = _resolveComponent("a-menu");
      return !_unref(isMobile)() && footerShow.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.links, (list, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "f-nav-list",
          key: index
        }, [_createElementVNode("h3", null, _toDisplayString(list.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.list, (item, index) => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: index
          }, [!item.jump ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: item.href,
            onClick: _cache[0] || (_cache[0] = $event => scrollTop())
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.msg), 1)]),
            _: 2
          }, 1032, ["to"])) : (_openBlock(), _createElementBlock("a", {
            key: 1,
            href: item.href,
            onClick: $event => openUrl(item.jump)
          }, _toDisplayString(item.msg), 9, _hoisted_4))], 64);
        }), 128))]);
      }), 128))]), _hoisted_5, _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("a", {
        href: `tel: ${data.phone_}`,
        class: "phone"
      }, _toDisplayString(data.phone), 9, _hoisted_10), _createElementVNode("a", {
        href: `tel: ${data.tel_}`,
        class: "phone"
      }, _toDisplayString(data.tel), 9, _hoisted_11)]), _createElementVNode("a", {
        href: `mailto: ${data.email}`,
        class: "email"
      }, "咨询邮箱：" + _toDisplayString(data.email), 9, _hoisted_12), _createElementVNode("div", _hoisted_13, [_createVNode(_component_a_tooltip, {
        class: "applets-dialog",
        color: "#fff"
      }, {
        title: _withCtx(() => [_hoisted_14]),
        default: _withCtx(() => [_createElementVNode("div", {
          class: "icon",
          onMouseover: _cache[1] || (_cache[1] = $event => reportHandle('视频号'))
        }, _hoisted_16, 32)]),
        _: 1
      }), _createVNode(_component_a_tooltip, {
        class: "applets-dialog",
        color: "#fff"
      }, {
        title: _withCtx(() => [_hoisted_17]),
        default: _withCtx(() => [_createElementVNode("div", {
          class: "icon",
          onMouseover: _cache[2] || (_cache[2] = $event => reportHandle('公众号'))
        }, _hoisted_19, 32)]),
        _: 1
      }), _createVNode(_component_a_tooltip, {
        class: "applets-dialog",
        color: "#fff"
      }, {
        title: _withCtx(() => [_hoisted_20]),
        default: _withCtx(() => [_createElementVNode("div", {
          class: "icon",
          onMouseover: _cache[3] || (_cache[3] = $event => reportHandle('小程序'))
        }, _hoisted_22, 32)]),
        _: 1
      })])])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", null, [_hoisted_25, _createElementVNode("span", null, "增值电信业务经营许可证：" + _toDisplayString(data.licens), 1), _hoisted_26, _createElementVNode("a", _hoisted_27, "渝ICP备：" + _toDisplayString(data.icp), 1), _hoisted_28, _createElementVNode("span", null, "渝公网安备：" + _toDisplayString(data.record) + "号", 1)])])])])) : footerShow.value ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createVNode(_component_a_menu, {
        class: "qbq-menu bottom-menu",
        style: {
          "width": "100%"
        },
        mode: "inline",
        theme: "light"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.links, (item, index) => {
          return _openBlock(), _createBlock(_component_a_sub_menu, {
            key: index
          }, {
            expandIcon: _withCtx(() => [_hoisted_30]),
            title: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (litem, i) => {
              return _openBlock(), _createBlock(_component_a_menu_item, {
                key: i
              }, {
                default: _withCtx(() => [!litem.jump ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: litem.href,
                  onClick: _cache[4] || (_cache[4] = $event => scrollTop())
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(litem.msg), 1)]),
                  _: 2
                }, 1032, ["to"])) : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: litem.href,
                  onClick: $event => openUrl(litem.jump)
                }, _toDisplayString(litem.msg), 9, _hoisted_31))]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }), _createElementVNode("div", _hoisted_32, [_hoisted_33, _createElementVNode("p", null, [_hoisted_34, _createElementVNode("a", {
        href: `tel:${data.phone_}`,
        class: "phone"
      }, _toDisplayString(data.phone), 9, _hoisted_35), _createElementVNode("a", {
        href: `tel:${data.tel_}`,
        class: "phone"
      }, _toDisplayString(data.tel), 9, _hoisted_36)]), _createElementVNode("p", null, [_createElementVNode("a", {
        href: `mailto:${data.mail}`
      }, [_hoisted_38, _createTextVNode(_toDisplayString(data.email), 1)], 8, _hoisted_37)]), _createElementVNode("div", _hoisted_39, [_createVNode(_component_a_tooltip, {
        placement: "topLeft",
        color: "white",
        getPopupContainer: terget => terget.parentNode,
        trigger: "click"
      }, {
        title: _withCtx(() => [_hoisted_40]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_41, [_createElementVNode("img", {
          src: _unref(vadioCode)
        }, null, 8, _hoisted_42), _hoisted_43])]),
        _: 1
      }, 8, ["getPopupContainer"]), _createVNode(_component_a_tooltip, {
        placement: "top",
        color: "white",
        getPopupContainer: terget => terget.parentNode,
        trigger: "click"
      }, {
        title: _withCtx(() => [_hoisted_44]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_45, [_createElementVNode("img", {
          src: _unref(wechartCode),
          "show-menu-by-longpress": true
        }, null, 8, _hoisted_46), _hoisted_47])]),
        _: 1
      }, 8, ["getPopupContainer"]), _createVNode(_component_a_tooltip, {
        placement: "top",
        color: "white",
        getPopupContainer: terget => terget.parentNode,
        trigger: "click"
      }, {
        title: _withCtx(() => [_hoisted_48]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_49, [_createElementVNode("img", {
          src: _unref(appCode)
        }, null, 8, _hoisted_50), _hoisted_51])]),
        _: 1
      }, 8, ["getPopupContainer"])])]), _createElementVNode("div", _hoisted_52, [_createElementVNode("p", null, [_hoisted_53, _createElementVNode("span", null, "增值电信业务经营许可证：" + _toDisplayString(data.licens), 1), _hoisted_54, _createElementVNode("a", _hoisted_55, "渝ICP备：" + _toDisplayString(data.icp), 1), _hoisted_56, _createElementVNode("span", null, "渝公网安备：" + _toDisplayString(data.record) + "号", 1)])])])) : _createCommentVNode("", true);
    };
  }
};